//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { analytics } from "/src/main.js";

export default {
  name: "Player",
  props: {
    currentLesson: {
      default: null,
    },
    annotations: {
      default: () => {
        return [];
      },
    },
    initialStartTime: {
      default: 0,
    },
    loop: {
      default: false,
    },
  },
  data() {
    return {
      loaded: false,
      currentTime: 0,
      cameraAngle: "Front",
      playerSpeed: 1.0,
      isLoop: false,
      loopCount: 0,
      flip: false,
      showControls: false,
      showSections: true,
      playerVars: {
        autoplay: 0,
        controls: 0,
        rel: 0,
        modestbranding: 1,
        autohide: 1,
        start: 0,
        playsinline: 1,
      },
      playerVars2: {
        ...this.playerVars,
      },
      getTimeWorker: null,
    };
  },
  methods: {
    playVideo() {
      this.cameraAngle === "Front"
        ? this.player.playVideo()
        : this.player2.playVideo();
    },
    pauseVideo() {
      this.player.pauseVideo();
      this.player2.pauseVideo();
    },
    flipVideo() {
      this.flip = !this.flip;
      var route = this.$route.path;
      analytics.logEvent("videoFlipped", { src: `${route}` });
    },
    replay() {
      this.currentTime = 0;
      this.playVideo();
    },
    toggleMute() {
      if (this.$store.state.playerIsMuted) {
        this.player.unMute();
        this.player2.unMute();
        this.$store.commit("unMute");
      } else {
        this.player.mute();
        this.player2.mute();
        this.$store.commit("mute");
      }
    },
    toggleCamera() {
      if (this.cameraAngle === "Front" && this.backCamAvailCurrentTime) {
        this.player2.seekTo(
          this.currentTime + parseFloat(this.currentLesson.backCamSrcOffset)
        );
        this.cameraAngle = "Back";
        this.player2.playVideo();
        this.player.pauseVideo();
      } else {
        this.cameraAngle = "Front";
        this.player.playVideo();
        this.player2.pauseVideo();
      }
      var route = this.$route.path;
      analytics.logEvent("toggleCamera", { src: `${route}` });
    },
    toggleLoop() {
      this.isLoop = !this.isLoop;
      var route = this.$route.path;
      analytics.logEvent("videoLooped", { src: `${route}` });
    },
    changeSpeed() {
      const speedSettings = [1.5, 1, 0.75, 0.5];
      const currentIdx = speedSettings.indexOf(this.playerSpeed);
      this.playerSpeed =
        currentIdx < speedSettings.length - 1
          ? speedSettings[currentIdx + 1]
          : speedSettings[0];
      this.player.setPlaybackRate(this.playerSpeed);
      this.player2.setPlaybackRate(this.playerSpeed);
    },
    scrubVideo(value) {
      this.currentTime = value;
      this.player.seekTo(this.currentTime);
      if (this.cameraAngle === "Back" && this.backCamAvailCurrentTime) {
        this.player2.seekTo(
          parseFloat(this.currentTime) +
            parseFloat(this.currentLesson.backCamSrcOffset)
        );
      }
    },
    goToFigure(startTime, idx) {
      this.currentTime = startTime;
      this.player.seekTo(this.currentTime);
      this.$store.commit("setFigure", idx);
      if (this.$store.state.playerState === "ended") {
        this.player.playVideo();
      }
      var route = this.$route.path;
      analytics.logEvent("annotationClicked", { src: `${route}` });
    },
    async playing() {
      this.$store.commit("changeState", "playing");
      this.$store.commit(
        "setDuration",
        Math.round(await this.player.getDuration())
      );
      clearInterval(this.getTimeWorker);
      this.getTimeWorker = setInterval(async () => {
        this.currentTime = await this.player.getCurrentTime();
      }, 100);
      this.$emit("playing", this.player);
    },
    async paused() {
      clearInterval(this.getTimeWorker);
      this.$store.commit("changeState", "paused");
    },
    ended() {
      clearInterval(this.getTimeWorker);
      this.$store.commit("changeState", "ended");
      this.$store.commit("setFigure", 0);
    },
    openFullscreen() {
      var elem = this.$refs.container;
      elem.requestFullscreen
        ? elem.requestFullscreen()
        : elem.webkitRequestFullscreen
        ? elem.webkitRequestFullscreen()
        : elem.msRequestFullscreen
        ? elem.msRequestFullscreen()
        : null;
      screen.orientation.lock("landscape-primary");
      analytics.logEvent("videoFullScreened", { src: `${this.$route.path}` });
    },
    closeFullscreen() {
      document.exitFullscreen
        ? document.exitFullscreen()
        : document.webkitExitFullscreen
        ? document.webkitExitFullscreen()
        : document.msExitFullscreen
        ? document.msExitFullscreen()
        : null;
    },
    checkDataLoaded() {
      return new Promise((resolve) => {
        setInterval(() => {
          if (this.annotations && this.currentLesson && this.initialStartTime != null) {
            resolve(true);
            this.loaded = true;
          }
        }, 500);
      });
    },
  },
  watch: {
    timeToNextFigure(val) {
      if (val <= 0 && this.$store.state.playerState === "playing") {
        if (this.isLoop === true) {
          this.player.seekTo(
            this.annotations[this.currentFigureIndex].startTime
          );
          this.loopCount += 1;
        } else if (this.currentFigureIndex < this.annotations.length - 1) {
          this.$store.commit("nextFigure");
        }
      }
    },
    timeSinceFigureStarted(val) {
      if (
        val < 0 &&
        this.$store.state.playerState === "playing" &&
        this.isLoop === false &&
        this.currentFigureIndex > 0
      ) {
        this.$store.commit("prevFigure");
      }
    },
    backCamAvailCurrentTime(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.toggleCamera();
      }
    },
    currentFigureIndex() {
      this.$refs[this.currentFigureIndex][0].$el.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    },
    initialStartTime() {
      this.checkDataLoaded().then(() => {
        var annoIdx = this.annotations.findIndex(
          (anno) => anno.startTime === this.initialStartTime
        );
        this.goToFigure(this.initialStartTime, annoIdx);
      });
    },
    loopCount(val) {
      if (val > 3) {
        this.pauseVideo();
        this.loopCount = 0;
      }
    },
  },
  computed: {
    player() {
      return this.$refs.youtube.player;
    },
    player2() {
      return this.$refs.youtube2.player;
    },
    videoId() {
      return this.currentLesson ? this.currentLesson.YTID : null;
    },
    backCamAvailCurrentTime() {
      return this.currentLesson
        ? this.currentLesson.backCamStart
          ? this.currentLesson.backCamStart <= this.currentTime &&
            this.currentTime < this.currentLesson.backCamEnd
            ? true
            : false
          : false
        : false;
    },
    currentFigureIndex() {
      return this.$store.state.currentFigureIndex;
    },
    nextFigureStartTime() {
      if (this.annotations != null) {
        try {
          return this.annotations[this.currentFigureIndex + 1].startTime;
        } catch {
          console.error("Could not get next figure start time.");
        }
      }
      return 99999;
    },
    currentFigureStartTime() {
      if (this.annotations != null) {
        try {
          return this.annotations[this.currentFigureIndex].startTime;
        } catch {
          console.error("Could not get current figure start time.");
        }
      }
      return 99999;
    },
    timeToNextFigure() {
      return this.nextFigureStartTime - this.currentTime;
    },
    timeSinceFigureStarted() {
      return this.currentTime - this.currentFigureStartTime;
    },
  },
  mounted() {
    if ("ontouchstart" in window || navigator.maxTouchPoints) {
      this.showControls = true;
    }

    this.loop ? (this.isLoop = true) : (this.isLoop = false);

    this.checkDataLoaded().then(() => {
      var annoIdx = this.annotations.findIndex(
        (anno) => anno.startTime === this.initialStartTime
      );
      this.goToFigure(this.initialStartTime, annoIdx);
    });
  },
};
